import React from 'react';

export const FloridaInfo = () => (
    <div>
        <p className="eds-text-bl eds-l-mar-bot-4">State of Florida</p>
        <p className="eds-l-mar-bot-1">
            <strong>Small Business Emergency Bridge Loan Program</strong>{' '}
            |&nbsp;
            <a
                href="https://floridadisasterloan.org/"
                target="_blank"
                rel="noopener noreferrer"
                className="eds-text-weight--heavy"
            >
                Apply
            </a>
        </p>
        <p>
            Short-term, interest-free working capital loans intended to “bridge
            the gap” between the time a major catastrophe hits and when a
            business has secured longer term recovery resources.
        </p>
    </div>
);
